import { useQuery } from 'react-query'

import { QUERY_KEYS } from '../../api'
import VehiclesApi from './api'
import { ApiParams } from '../../types'

interface UseVehiclesViewProps extends ApiParams {}

const useVehiclesView = ({ filters }: UseVehiclesViewProps) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.VEHICLES_ADMIN, filters],
    () => VehiclesApi.getVehicles({ filters }),
    {
      staleTime: Infinity,
    },
  )

  return {
    trucks: data,
    isLoading,
  }
}

export default useVehiclesView
